import { PageLink } from '../../../../../../_metronic/layout/core'
import { RiskScoreChangeKind } from '../../../api/logs.types'

export const breadCrumbs: Array<PageLink> = [
  {
    title: 'Риск-баллы',
    path: '/logs/risk-score',
    isSeparator: false,
    isActive: true,
  },
]

export const ITEMS_PER_PAGE = 100

export const SEARCH_FIELDS = {
  EXTERNAL_USER_ID: 'externalUserId',
  EXTERNAL_USER_TOKEN: 'externalUserToken',
} as const

export const SEARCH_FIELD_OPTIONS = [
  { value: SEARCH_FIELDS.EXTERNAL_USER_ID, label: 'ID клиента' },
  { value: SEARCH_FIELDS.EXTERNAL_USER_TOKEN, label: 'Токен клиента' },
]

export const RISK_SCORE_CHANGE_KIND_LABELS: Record<RiskScoreChangeKind, string> = {
  RISK_SCORE: 'Риск балл',
  MATCHING_PAYOUT_RESTRICTION: 'Запрет выплат в мэтчинг',
}

/**
 * Значения журнала читаются по типу записи: у балла это число, у запрета выплат — 0/1, и показать
 * его цифрой значило бы выдать запрет за изменение балла.
 */
export const formatRiskScoreLogValue = (kind: RiskScoreChangeKind, value: number): string => {
  if (kind === 'MATCHING_PAYOUT_RESTRICTION') {
    return value ? 'Включён' : 'Выключен'
  }

  return String(value)
}
